export interface ProxyHealthFailedStart {
  id: number;
  macId: string;
  locationApiId: string;
  command: string;
  lastError: string | null;
  createdAt: string;
}

export interface ProxyHealthStuckCommand {
  id: number;
  macId: string;
  locationApiId: string;
  command: string;
  status: string;
  attempts: number;
  allianceCommandId: string | null;
  lastError: string | null;
  requestedBy: string | null;
  client: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProxyHealthGatewayRow {
  locationApiId: string;
  locationName: string | null;
  gatewayName: string;
  gatewayStatus: string;
  latestStatusUpdate: string | null;
  macAddress: string | null;
  antennaType: string | null;
  releaseVersion: number | null;
  checkedAt: string;
}

export interface ProxyHealthPayload {
  generatedAt: string;
  proxy: {
    ok: boolean;
    db: "ok" | "error";
    alliance: {
      ok: boolean;
      lastSuccessAt: string | null;
      error?: string;
      rateLimit: {
        remaining: number | null;
        resetAt: string | null;
        limit: number | null;
        updatedAt: string | null;
      };
      stats: {
        requestsTotal: number;
        responses429: number;
        retriesTotal: number;
        throttleWaitMsTotal: number;
        last429At: string | null;
      };
    };
    ingest: {
      enabled: boolean;
      wsConnected: boolean;
      subscribedLocations: number;
      knownLocations: number;
      lastStatusAt: string | null;
      lastErrorSweepAt: string | null;
      lastErrorWsAt: string | null;
      lastWsConnectedAt: string | null;
      lastBootstrapAt: string | null;
      lastError?: string;
    };
    commands: {
      open: number;
      stuck: number;
      stuckThresholdMs: number;
      failedStartsLast1h: number;
      recentFailedStarts: ProxyHealthFailedStart[];
      stuckCommands: ProxyHealthStuckCommand[];
    };
    gateways: {
      online: number;
      offline: number;
      total: number;
      lastSweepAt: string | null;
      lastError?: string;
      gateways: ProxyHealthGatewayRow[];
    };
    uptimeSeconds: number;
  };
}

/** Row from GET /ops/proxy-health/commands (sqi-proxy alliance_commands). */
export interface ProxyCommandRow {
  id: number;
  mac_id: string;
  location_api_id: string;
  command: string;
  params_json: unknown;
  alliance_command_id: string | null;
  status: string;
  attempts: number;
  last_error: string | null;
  requested_by: string | null;
  client: string;
  idempotency_key: string | null;
  created_at: string;
  updated_at: string;
}

export interface ProxyCommandHistoryPayload {
  data: ProxyCommandRow[];
  pagination: {
    page: number;
    pageSize: number;
    totalRows: number;
    totalPages: number;
  };
}

export const PROXY_COMMAND_STATUSES = [
  "PENDING",
  "QUEUED",
  "COMPLETED",
  "FAILED",
] as const;

export const PROXY_COMMAND_NAMES = [
  "GET_PRICE",
  "SET_CYCLE_SELECTIONS",
  "START",
  "START_DRYER_WITH_TIME",
  "PROGRAM_OUT_OF_ORDER",
] as const;

export const PROXY_COMMAND_CLIENTS = ["portal", "kiosk", "liveness"] as const;
